import {type OverrideOrDefaultData, type Pointer, type PS, SYSTEM_CONTAINER_TYPE} from '@wix/document-services-types'
import slots from '../../slots/slots'
import type {ManifestApi, ManifestExtensionAPI, BuilderComponentsExtensionAPI} from '@wix/document-manager-extensions'
import experiment from 'experiment-amd'
import {populateSlotWithSystemContainer} from './slotPopulationUtils'

const getContainerData = (manifest: ManifestApi, componentRef: Pointer, includeInnerElements: boolean) => {
    return manifest
        .getData(componentRef, includeInnerElements, [{prop: 'container'}])
        .filter(
            ({metaData}) =>
                metaData?.containerType === 'placeholder' ||
                metaData?.containerType === 'template' ||
                metaData?.containerType === 'simple'
        )
}

const handleElementPopulate = (ps: PS, componentRef: Pointer, containersList: OverrideOrDefaultData[]) => {
    const existingSlots = slots.getSlotNames(ps, componentRef)
    containersList.forEach((container: OverrideOrDefaultData) => {
        const slotName = container.prop
        if (existingSlots.includes(slotName)) {
            return
        }

        populateSlotWithSystemContainer(ps, componentRef, slotName, container.path)
    })
}

const builderComponentsContainerPopulationHook = (ps: PS, componentRef: Pointer) => {
    if (!experiment.isOpen('dm_autoPopulateSlotToContainer')) {
        return
    }
    const {manifest} = ps.extensionAPI as ManifestExtensionAPI
    const {builderComponents} = ps.extensionAPI as BuilderComponentsExtensionAPI

    const compStructure = ps.dal.get(componentRef)

    if (!builderComponents.isBuilder(compStructure?.componentType)) return

    if (compStructure.componentType === SYSTEM_CONTAINER_TYPE) return

    const containersListIncludeInnerElement = getContainerData(manifest, componentRef, true)

    handleElementPopulate(ps, componentRef, containersListIncludeInnerElement)
}

export default {
    builderComponentsContainerPopulationHook
}
